// @ts-strict-ignore
export class LabelFormat {

  public static readonly VALIGN_TOP: string = 'top';
  public static readonly VALIGN_MIDDLE: string = 'middle';
  public static readonly VALIGN_BOTTOM: string = 'bottom';
  public static readonly VALIGN_DEFAULT: string = LabelFormat.VALIGN_MIDDLE;
  public static readonly DEFAULT_LABELING_BORDER_COLOR: string = '#0000FF';
  public static readonly DEFAULT_BACKGROUND_COLOR: string = '#FFFFFF';
  public static readonly DEFAULT_CELL_WIDTH: number = 40;
  public static readonly DEFAULT_CELL_HEIGHT: number = 75;

  // custom background color for cell, can be set according to color of label material according to SMAR-53
  public backgroundColor: string = LabelFormat.DEFAULT_BACKGROUND_COLOR; // values can be like: '#0000FF' or 'rgb(0,0,255)', default is white
  public direction: number = 0;
  public verticalAlign: string = LabelFormat.VALIGN_DEFAULT;
  // custom border color to mark certain cells in label editor
  public borderColor: string = null; // values can be like: '#0000FF' or 'rgb(0,0,255)'

  // width of label material, allows altering of width of cell in label editor according to SMAR-53
  // width information must be provided for each spanData individually.
  // So for merged cells (spanning multiple columns), parent only includes his own width and not total width.
  public width: number = LabelFormat.DEFAULT_CELL_WIDTH;
  // height of label material, allows altering of height of cell in label editor according to SMAR-53
  // previously in case only non-multilined label materials were shown in label editor, default height was 50
  // with introduction of individual sizes for each label material (see SMAR-53),
  // different default height of 50 is not used anymore, 75 only set for developing purposes (fallback) here.
  // Height information of spanData in rows for multiline support ("sublines") will be ignored and could be set to null.
  // So total height of multilined label is specified in "parent" spanData in such case (first row belonging to label material).
  // So even in case there are already multiple lines with text, height is always taken from spanData in first row of label material.
  // Height information for merged cells spanning multiple columns is assumed to be equal on each merged spanData.
  public height: number = LabelFormat.DEFAULT_CELL_HEIGHT;

  constructor(
    backgroundColor: string = LabelFormat.DEFAULT_BACKGROUND_COLOR, direction: number = 0, verticalAlign: string = LabelFormat.VALIGN_DEFAULT,
    borderColor: string = null, width: number = LabelFormat.DEFAULT_CELL_WIDTH, height: number = LabelFormat.DEFAULT_CELL_HEIGHT) {
    if (backgroundColor === null) {
      this.backgroundColor = LabelFormat.DEFAULT_BACKGROUND_COLOR;
    } else {
      this.backgroundColor = backgroundColor;
    }
    if (direction < 0) {
      this.direction = 0;
    } else {
      this.direction = direction;
    }
    if (verticalAlign === null) {
      this.verticalAlign = LabelFormat.VALIGN_DEFAULT;
    } else {
      this.verticalAlign = verticalAlign;
    }
    this.borderColor = borderColor;
    this.width = width;
    this.height = height;
  }

  public clone(): LabelFormat {
    const clone: LabelFormat = new LabelFormat();
    clone.backgroundColor = this.backgroundColor;
    clone.direction = this.direction;
    clone.verticalAlign = this.verticalAlign;
    clone.borderColor = this.borderColor;
    clone.width = this.width;
    clone.height = this.height;
    return clone;
  }

}
